import {
	getTapTraitsForSiteUser,
	type GetTapTraitsForSiteUserInput,
} from '@post-office/util-tap-traits';

export const TEMPLATE_XFLOW_REMINDER_TRAIT_KEY = 'twc_xflow_conf_meeting_pages_templates_reminder';
export const TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE = 'remind';

export type TemplateXflowReminderTapTraitContext = {
	tapReminderTrait?: typeof TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE;
};

export const getTemplateXflowReminderTapTrait = async (
	input: GetTapTraitsForSiteUserInput,
): Promise<TemplateXflowReminderTapTraitContext> => {
	const traits = await getTapTraitsForSiteUser(input);
	const reminder = traits?.[TEMPLATE_XFLOW_REMINDER_TRAIT_KEY];

	return {
		tapReminderTrait:
			reminder === TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE
				? TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE
				: undefined,
	};
};
